/* istanbul ignore file */
import { Cookie } from '@nuxt-common/util/app/utils/cookie';
import $http from '@vue-util/http';

const signInErrorCodes = ['18005', '18027', '18002', '18116', '18003', '18118', '18004'];
const sessionOutErrorCodes = ['02011', '09007'];

function redirect(url) {
  window.location.href = url;
}

function relativeRedirect(relativePath) {
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split(currentUrl);
  redirect(urlParts[0] + relativePath + urlParts[1]);
}

function handleSignOut() {
  const domain = Cookie.getHostName();
  Cookie.remove('SignedIn', null, {
    domain,
  });
  Cookie.set('SE', 1, 'SNSGCs', {
    domain,
  });
  Cookie.set('FORWARDPAGE_KEY', window.location, null, {
    domain,
  });
  relativeRedirect('/account/signin');
}

export default function () {
  $http.interceptors.response.use(
    (response) => {
      const message = response?.data?.WalletInfo?.error?.message;
      const errorCode = response?.data?.WalletInfo?.error?.errorCode;

      // Handle 200 + session timeout condition
      // Safe: guard before calling string methods
      const isSessionTimeout = !!message && typeof message === 'string' && message.toLowerCase().includes('session timeout');

      if (errorCode && isSessionTimeout && sessionOutErrorCodes.includes(errorCode)) {
        handleSignOut();
      }

      return response; // return in all cases
    },
    (error) => {
      // Avoid unsafe optional chaining with destructuring.
      // Provide a default empty object to prevent TypeError.
      const { status, data } = error?.response ?? {};

      if (status === 401) {
        let errorCode;

        if (data?.user?.error?.errorCode) {
          errorCode = data.user.error.errorCode;
        } else {
          errorCode = data?.errors?.error?.[0]?.errorCode;
        }

        // If the user is in persistent login and is unable to sign in, do not redirect to sign in page.
        if (signInErrorCodes.includes(errorCode)) {
          return Promise.reject(error);
        }

        handleSignOut();
      }

      return Promise.reject(error);
    },
  );
}
